export const API_TIMEOUTS = Object.freeze({
  DEFAULT: 15000,
  HEAVY: 30000,
  LIVE_MUTATION: 12000,
  // Görsel yükleme: birkaç megabaytlık dosya sahadaki mobil bağlantıda
  // 15 saniyeden uzun sürüyor ve varsayılan zaman aşımı isteği yarıda kesiyordu.
  UPLOAD: 120000,
});

export const API_CACHE_TTLS = Object.freeze({
  NONE: 0,
  LIVE: 2000,
  STANDINGS: 15000,
  PLAYER_STATS: 30000,
  PLAYERS: 30000,
  TEAMS: 60000,
  COMPLETED_MATCH: 60000,
  REFERENCE: 300000,
});

export const GET_RETRY_DELAYS = Object.freeze([500, 1500]);

